import axios from 'axios';
import { salesFlowDebug, salesFlowError } from '../../utils/salesFlowLogger';

const axiosClient = axios.create({
  baseURL: '',
  timeout: 45_000
});

// NOTE: Pede json como retorno
axiosClient.defaults.headers.common['Accept'] = 'application/json';

// NOTE: Qualquer header pode ser configurado para ser utilizado sempre
// mainAxios.defaults.headers.common['api-key'] = 'abc';

// NOTE:
// Esta configuração monitora as respostas das requisições
// Se receber alguma resposta com status 401 entendo que o usuário não está logado a API
// Sendo assim redireciono a página para a rota ROOT, Onde está a página de login
axiosClient.interceptors.response.use(function (response) {
  salesFlowDebug('AxiosClient', `Request successful: ${response.config?.method?.toUpperCase()} ${response.config?.url}`);
  return response.data;
}, function (error) {
  salesFlowError('AxiosClient', 'Request failed', {
    method: error.config?.method,
    url: error.config?.url,
    status: error.response?.status,
  });

  if (error.response) {
    salesFlowDebug('AxiosClient', `Response error: status=${error.response.status} data=${JSON.stringify(error.response.data)}`);
    if (error.response.status === 401) {
      window.location = '/public';
    }
  } else if (error.request) {
    salesFlowDebug('AxiosClient', `No response: ${error.message}`);
  } else {
    salesFlowDebug('AxiosClient', `Setup error: ${error.message}`);
  }
  
  return Promise.reject(error.response || error.message);
});

export default axiosClient;
